interface SlotRowModelOptions {
  trClass?: any;
  tdClass?: any;
  ruler?: boolean;
}

export class SlotRowModel {
  public readonly isSlotRow: boolean = true;
  public readonly slotName: string;
  public readonly bindings: Record<string, any>;
  public readonly trClass: any;
  public readonly tdClass: any;
  public readonly ruler: boolean;

  constructor(
    slotName: string,
    bindings: Record<string, any>,
    options?: SlotRowModelOptions,
  ) {
    this.slotName = slotName;
    this.bindings = bindings;
    this.trClass = options?.trClass || null;
    this.tdClass = options?.tdClass || null;
    this.ruler = options?.ruler || false;
  }
}
